import { FC } from 'react';
import { Tabs as AntdTabs, TabsProps } from 'antd';
import styled from 'styled-components';
import { useThemeContext, themeConfig } from '@/shared/theme';

export const Tabs: FC<TabsProps> = ({
  tabPosition = 'top',
  type = 'card',
  ...props
}) => {
  const { theme } = useThemeContext();

  return (
    <TabsWrapper
      inactiveTabBg={themeConfig[theme].colors.contentBgSecondary}
      inactiveTabHoberColor={themeConfig[theme].colors.text}
      activeTabColor={themeConfig[theme].colors.activeItemPrimaryColor}
      activeTabBg={themeConfig[theme].colors.contentBg}
      type={type}
    >
      <AntdTabs
        type={type}
        tabPosition={tabPosition}
        tabBarGutter={3}
        tabBarStyle={{
          borderBottom:
            tabPosition === 'top'
              ? `1px solid ${themeConfig[theme].colors.contentBgSecondary}`
              : 'none !important',
        }}
        {...props}
        style={{ width: '100%', height: '100%' }}
      />
    </TabsWrapper>
  );
};

const TabsWrapper = styled.div<{
  inactiveTabBg: string;
  inactiveTabHoberColor: string;
  activeTabColor: string;
  activeTabBg: string;
  type: TabsProps['type'];
}>`
  width: 100%;
  height: 100%;

  .ant-tabs-tabpane {
    height: 100%;
  }
  .ant-tabs-content {
    height: 100%;
  }
  .ant-tabs-tab:not(.ant-tabs-tab-active) {
    background: ${({ inactiveTabBg, type }) =>
      type === 'card'
        ? inactiveTabBg + '!important'
        : 'transparent !important'};
  }
  .ant-tabs-tab:hover:not(.ant-tabs-tab-active) {
    filter: brightness(104%);
    color: ${({ inactiveTabHoberColor }) => inactiveTabHoberColor} !important;
  }
  .ant-tabs-tab-active {
    background: ${({ activeTabBg, type }) =>
      type === 'card' ? activeTabBg + '!important' : 'transparent !important'};
    color: ${({ activeTabColor }) => activeTabColor} !important;
  }
  .ant-tabs-tab-btn:focus:not(:focus-visible) {
    color: ${({ activeTabColor }) => activeTabColor} !important;
  }
  .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ activeTabColor }) => activeTabColor} !important;
  }
`;
